module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "chapter",
      "id": "ch01"
    }
  }, [_c('h1', {
    staticClass: "cn"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "p19"
    }
  }), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/ChiLeong0006#toc"
    }
  }, [_vm._v("CHAPTER ONE")])]), _vm._v(" "), _c('h1', {
    staticClass: "ct"
  }, [_vm._v("Making Recipe Books in Early Modern England")]), _vm._v(" "), _c('h1', {
    staticClass: "cs"
  }, [_vm._v("Material Practices and the Social Production of Knowledge")]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "data-locator": "p19"
    }
  }), _vm._v("Archdale Palmer (1610–1673), gentleman landowner, high sheriff, and lord lieutenant of Leicestershire, had a habit of collecting recipes."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/ChiLeong0018#en72",
      "id": "en72r"
    }
  }, [_vm._v("1")])]), _vm._v(" On 27 November 1658, Palmer, then in his late forties, took his first step toward creating his collection by purchasing a blank notebook for the sum of sixpence. To mark the occasion he twice wrote on the flyleaf, “Arch: Palmer his book” and the date he bought it. A little over a month later, on 3 January 1658/59, Palmer entered his first tidbit of medical information—a recipe “for running gowte” collected from “cozen” Mary Williams. For the next fourteen years Palmer maintained a healthy interest in recipes and an active collecting habit. He continued to add to this notebook regularly, gathering new recipes every few months. On 8 June 1672, a little over a year before his death on 6 August 1673 at age sixty-three, Palmer wrote his last entry. By then he had amassed more than 150 pieces of medical, culinary, household, and veterinary information from his family, friends, and chance acquaintances.")]), _vm._v(" "), _c('p', [_vm._v("Almost twenty years after Palmer collected his last recipe, another family from another county began a similar project. The Whitney Collection of Cookbooks Manuscript 9 is a household recipe collection written in what was once a commonplace book. The notebook contains nearly three hundred recipes, scattered among sections of philosophical and religious writings."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/ChiLeong0018#en73",
      "id": "en73r"
    }
  }, [_vm._v("2")])]), _vm._v(" In contrast to Archdale Palmer’s notebook, where authorship "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p20"
    }
  }), _vm._v("and agency are clearly stated, the compilers of the Bennetts’ notebook were more reticent in asserting their role as creators of the work. A recipe likely written in 1707 or 1708, titled “for my son Samuel Bennetts lame Knee William Coleman of Brewham used when he was neere 13 years of Age” connects the collection with Philip Bennett the younger (d. 1725) and Anne Strode Bennett (d. 1735) of Somerset."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/ChiLeong0018#en74",
      "id": "en74r"
    }
  }, [_vm._v("3")])]), _vm._v(" Starting in 1694, for nearly four decades the Bennetts worked together to gather recipes from their family, friends, and neighbors and recorded them in their notebook.")]), _vm._v(" "), _c('p', [_vm._v("Like the scores of other household recipe books surviving from the period, the Palmer and Bennett books contain a miscellany. Readers find instructions for making remedies to alleviate a wide range of general ailments such as scalds and burns, rickets, giddiness of the head, gout, ague, rupture, nosebleeds, and toothaches. Archdale Palmer and the Bennetts cast a wide net when seeking out recipes, and their notebooks present an assortment of information taken from oral, manuscript, and printed sources described as “Perkins’ almanac” or “Dr Micklethywat” or “sonne Wm Palmers wife Martha.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/ChiLeong0018#en75",
      "id": "en75r"
    }
  }, [_vm._v("4")])])]), _vm._v(" "), _c('p', [_vm._v("We know a great deal about the collecting habits of both sets of compilers because they took unusual care in recording the time, location, and source of recipe donations. The two notebooks were organized chronologically by date of entry, and this journal-like arrangement enables us to situate the practical know-how needs and the place of recipe collecting within the everyday lives of the Palmers and the Bennetts."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/ChiLeong0018#en76",
      "id": "en76r"
    }
  }, [_vm._v("5")])]), _vm._v(" Reading between the lines, it is clear that though adding to their recipe books might not have occurred daily, for both families seeking out and collecting new recipe knowledge was constant and sustained for many years. Filled with bountiful details, the collections also offer tantalizing hints to Palmer’s and the Bennetts’ social and knowledge networks and to social occasions, spaces, and actors involved in the exchange of recipes. Additionally, they reveal contemporary assessment criteria for collating practical knowledge and the various processes used to construct treasuries of household know-how. Together these two books provide a unique glimpse into both processes of recipe knowledge collection and the social worlds of early modern England.")]), _vm._v(" "), _c('p', [_vm._v("Guided by these two recipe collections, this chapter explores the multiple paths by which householders encountered recipe knowledge and the various ways they recorded it. The chapter opens with a general overview of patterns of recipe collecting: adopting “starter” collections and gathering single recipes. The rest focuses on four main themes: the importance"), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p21"
    }
  }), _vm._v(" of family; sociability and knowledge making; recipes and gift economies; and the social and cultural function of recipe exchange. Overall I argue that within early modern households, gathering recipe knowledge was shaped by family and social networks, economies of social credit and debts, and systems of gift and information exchange.")]), _vm._v(" "), _c('h2', {
    staticClass: "ah",
    attrs: {
      "id": "ah0101"
    }
  }, [_vm._v("Getting Started")]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("In 1694, when Philip and Anne Bennett began their recipe book project, they turned for information to their neighbor, the widowed Florence Mompesson. Thomas (d. before 1693) and Florence Mompesson (d. 1698) and their elder daughter, also named Florence (d. c. 1709), lived across the river Brue at a nearby farm known as North Court or Batts. The entries in the Bennett notebook suggest friendly relations between the two households."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/ChiLeong0018#en77",
      "id": "en77r"
    }
  }, [_vm._v("6")])]), _vm._v(" Before her death, the elder Florence Mompesson contributed in several ways to the Bennetts’ notebook of recipe knowledge. First, when Philip and Anne began their recipe book in 1694, they copied a long series of culinary recipes from Mompesson’s collection to form their own “starter collection”—a practice I discuss further below. As Philip and Anne began gathering single recipes to build on this “starter” collection, they again turned to Mompesson. She obliged on two occasions and offered them instructions on making ointments, oils, and remedies to ease burns and rickets."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/ChiLeong0018#en78",
      "id": "en78r"
    }
  }, [_vm._v("7")])]), _vm._v(" A number of these had themselves been given to Mompesson by others. The ointment recipe, for example, came with the endorsement that Mompesson’s Aunt Drew of Exeter had “cured many of the cancer at the first coming,” and the recipe for the oil of charity came with the tag “This madam Moore did much good with.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/ChiLeong0018#en79",
      "id": "en79r"
    }
  }, [_vm._v("8")])]), _vm._v(" By sharing her medical and culinary knowledge with the Bennetts, Mompesson opened access to her own network of family and social contacts. This group of “Mompesson” recipes in the Bennett family notebook highlights both the common pattern of recipe collecting and the important role of sociability in making recipe knowledge.")]), _vm._v(" "), _c('p', [_vm._v("When Philip and Anne Bennett chose to adopt a section of the Mompesson recipe book as the first step toward their own collection, they were joining in a well-established practice. Whether they obtained them from family members or from friends and acquaintances, many recipe compilers began their books with “starter” collections. These take the form of a large section of copied text written in a uniform hand, occurring "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p22"
    }
  }), _vm._v("at the beginning of the manuscript. The notebook is then filled up with a substantial number of additional recipes in a different hand or hands. This combination of a group of recipes clearly transcribed from another collection and additional recipes gathered singly is one of the most common constructions. Many of these starter portions are written out in a neat scribal hand, in contrast to the less practiced hands used to fill in the blank pages with additional recipes, and they are often well organized, with an index or a table of contents. In fact, with many of the collections, the method of organization disintegrates only after the additional recipes are put in. Many starter collections are copied leaving blank pages for later additions; some were written only on the recto pages, leaving the verso pages to be filled by subsequent owners of the notebook. If indexes and tables of contents accompany the starter portion of the collection, space is left within them for additional entries.")]), _vm._v(" "), _c('p', [_vm._v("Aside from the Bennett family book, another good example of a “starter” collection is the notebook owned by Anne Brumwich, Rhoda Hussey Fairfax, Ursula Fairfax, and Dorothy Cartwright."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/ChiLeong0018#en80",
      "id": "en80r"
    }
  }, [_vm._v("9")])]), _vm._v(" The first folio of the manuscript bears the following inscription: “Mris Anne Brumwich her Booke of Receipts or Medicines for severall sores and other Infirmities.” The hand that wrote this inscription also added a set of recipes organized alphabetically by ailment. Thus the Brumwich hand begins with recipes for the ague and continues with recipes for consumption, cough, and so on. At the end of each section, space is left for additional recipes. An index was constructed at the end of the volume, where space was again left for additions. The recipes written in the Brumwich hand are not attributed to any particular author. The uniformity and organization of these recipes suggest they were copied to order out of Anne Brumwich’s book—all the recipes were by Anne Brumwich, hence there was no need to reiterate authorship. Once the starter collection came into the hands of Rhoda Hussey, soon to be Rhoda Fairfax, she began to fill in the empty pages with her own recipes for the same ailments and updated the index. The subsequent owners of the volume, Rhoda’s daughter Ursula and granddaughter Dorothy Cartwright, also added their own recipes. The book as it exists now has almost alternating sections of the Brumwich hand and the later hands. The recipes added by the later hands bear the signs of compilation, and most note their authorship or origin. Rhoda Fairfax sometimes recorded the date when she obtained a particular recipe. Examples include “a pill commended for mee R. F. by Doctor Catlin, 1653 when I was very ill”; “The Yellow Salve—Lady Hussey’s "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p23"
    }
  }), _vm._v("29 September 1684,” and a recipe on a loose piece of paper titled “this was sent from London for the payne in my shoulder . . . R. F. the 29"), _c('sup', [_vm._v("th")]), _vm._v(" July 1682.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/ChiLeong0018#en81",
      "id": "en81r"
    }
  }, [_vm._v("10")])]), _vm._v(" It appears that the copy of Anne Brumwich’s collection provided Rhoda Fairfax with a base of medical knowledge and information that she built on and personalized during her lifetime, then passed on to her daughter.")]), _vm._v(" "), _c('p', [_vm._v("Not surprisingly, these starter portions are common in early modern recipe notebooks. Many householders elected to copy or adopt a group of already assembled recipes as the basis of their own collection. We might think of these as initial assemblages of household knowledge to give compilers a head start. The origin of these starter portions varied. Some, like the Bennetts, obtained their starter collections from neighbors or friends. Occasionally, as with those of the Temple and Bourne families we will encounter in later chapters, a family member might take the time to copy out the starter portion. In other cases compilers might themselves take the initiative to create these books, either by doing the copying themselves or by commissioning a scribe, as when Anne Fanshawe hired Joseph Averie to copy the collection of her mother, Margaret Harrison."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/ChiLeong0018#en82",
      "id": "en82r"
    }
  }, [_vm._v("11")])])]), _vm._v(" "), _c('p', [_vm._v("The presence of starter collections indicates that both the producer/donor and the receiver/future compiler saw a need for a ready-made set of recipes. Yet this need for general information was paired with a desire to personalize these collections and adapt them to one’s own requirements—hence the blank spaces left in each collection and the subsequent evaluation of the information they contained. Household recipe collections were by nature ever-expanding books of knowledge that changed according to the needs of the current owners.")]), _vm._v(" "), _c('p', [_vm._v("Whether armed with the starter collection or working from scratch with a blank notebook, men and women like Palmer and the Bennetts actively gathered single recipes or groups of recipes through various avenues. As I outline in the following sections, family, friends, and neighbors provided householders with an abundance of recipe knowledge. Yet family and social networks did much more than just supply new information; as I discuss below, they also shaped the very making of recipe knowledge.")]), _vm._v(" "), _c('h2', {
    staticClass: "ah",
    attrs: {
      "id": "ah0102"
    }
  }, [_vm._v("Working Together as a Family")]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("Family played a central role in collecting, exchanging, and recording recipe knowledge. Family members such as husbands and wives, fathers and "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p24"
    }
  }), _vm._v("sons, and mothers and daughters collaborated on their collections. Recipe gathering was often directed by the sickness and needs of individual family members and other household dependents. Additionally, recipe compilers often reached out to extended family and kin for new recipes. In this section I examine each of these areas in turn—collaborative compiling, collecting to cure, and calling on family and kin—to argue that making household recipe knowledge was a family affair.")]), _vm._v(" "), _c('h3', {
    staticClass: "bh",
    attrs: {
      "id": "bh0101"
    }
  }, [_vm._v("Collaborative Compiling")]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("When Philip and Anne Bennett decided to start writing down recipes in an old commonplace book, they were a long-married couple with a large and well-established family. Recipe collecting was a joint project for them. A recipe for “the collick,” gathered on 3 May 1719, comes with the endorsement that “my wife took it,” revealing Philip Bennett’s active role in the project."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/ChiLeong0018#en83",
      "id": "en83r"
    }
  }, [_vm._v("12")])]), _vm._v(" Entries made after Philip’s death in 1725 show that Anne also contributed to the family book. During this period it was not unusual for male and female family members to take collective responsibility for the health of the household. Contemporary correspondence reveals that fathers and husbands often wrote about the health, ailments, and subsequent treatment of their wives, children, and dependents, and at times took care to produce medicines—either with their own hands or, more likely in elite families, by instructing their servants."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/ChiLeong0018#en84",
      "id": "en84r"
    }
  }, [_vm._v("13")])]), _vm._v(" The actions of Philip and Anne Bennett make it clear that men’s interest in the family’s health extended to another kind of household medical activity: collecting and recording recipes.")]), _vm._v(" "), _c('p', [_vm._v("Philip and Anne were, of course, not the only husband and wife to work together on a recipe book. The recipe archive contains many such instances. One particularly clear example is the collection now known as "), _c('i', [_vm._v("Arcana Fairfaxiana")]), _vm._v(", created through the joint efforts of the Reverend Henry Fairfax and his wife, Mary Cholmeley Fairfax. Like many of the collections described above, the "), _c('i', [_vm._v("Arcana Fairfaxiana")]), _vm._v(" begins with a starter collection, probably created before Mary wedded Henry in 1627."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/ChiLeong0018#en85",
      "id": "en85r"
    }
  }, [_vm._v("14")])]), _vm._v(" This section is written in a clear hand and lists a series of medical recipes by ailment, followed by several recipes written in abbreviated Latin, suggesting that they were taken either from an apothecary’s formulary or from a physician’s notes."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/ChiLeong0018#en86",
      "id": "en86r"
    }
  }, [_vm._v("15")])]), _vm._v(" In this section of the book, if a recipe spanned more than one page, catchwords were used, suggesting that the text was first copied and then bound. This same hand also wrote a note on “Miss Barbara’s”"), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p25"
    }
  }), _vm._v(" lessons on the virginal and listed late sixteenth-century musicians on the back flyleaf.")]), _vm._v(" "), _c('p', [_vm._v("Once married, Henry and Mary began to fill in their recipe book together, but Henry seems to have taken the lead. His neat, precise hand is dominant throughout the book. He inscribed his name on the first folio of the volume, wrote out and translated a Latin epigram, compiled the indexes in the front (later crossed out) and back of the volume, and added information on weights and measures."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/ChiLeong0018#en87",
      "id": "en87r"
    }
  }, [_vm._v("16")])]), _vm._v(" He added a substantial number of single recipes on the blank pages of the notebook and also inserted several among information dealing with similar ailments. For example, he added a recipe “For a Sore Breast” under a recipe “to eale the greate heate in the brests of women or in the privy members of men.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/ChiLeong0018#en88",
      "id": "en88r"
    }
  }, [_vm._v("17")])])]), _vm._v(" "), _c('p', [_vm._v("Mary Cholmeley Fairfax also contributed to the volume and wrote in many recipes interleaved with those copied by Henry. One entry, seen in "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/ChiLeong0010#fig0101"
    }
  }, [_vm._v("figure 1.1")]), _vm._v(", is particularly interesting. The recipe is titled “Quene Elisabeth her pother for wind.” The recipe is entirely in Mary’s hand, but it bears corrections and additions in Henry’s. Mary’s version instructed the reader to “ponde all [the ingredients] together”; above this Henry added “& searce them.” Even though the recipe is titled “for wind,” Henry felt compelled to reiterate that “it expells winde” in Mary’s list of additional virtues."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/ChiLeong0018#en89",
      "id": "en89r"
    }
  }, [_vm._v("18")])]), _vm._v(" This is not the only recipe written by Mary and annotated by her husband. "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p26"
    }
  }), _vm._v("In a recipe to make “the green oyntment,” Mary wrote that one should take “red sage and rewe of ech a quart,” and Henry added above, “a pound or [a quart].” The quantity of two other herbs used in the recipe, bay leaves and wormwood, was given in pounds, and thus Henry may have added the extra measurement to ensure consistency."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/ChiLeong0018#en90",
      "id": "en90r"
    }
  }, [_vm._v("19")])]), _vm._v(" While there are scant written traces that Mary returned the favor by modifying Henry’s entries, another family member, yet to be identified, took the liberty of doing so. Written at the end of the book is a recipe by Henry offering instructions for making a consumption plaster. While Henry’s original instructions are frustratingly vague on the amount of ingredients required, a second hand clarified this by adding precise measurements and specific instructions for application—the “plaister is to be laid to the spoone of the stomack & cut to the bredth of a hand.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/ChiLeong0018#en91",
      "id": "en91r"
    }
  }, [_vm._v("20")])]), _vm._v(" Aside from these contemporary annotations, other family members also entered this collaborative project at various times.")]), _vm._v(" "), _c('figure', {
    staticClass: "figure",
    attrs: {
      "id": "fig0101"
    }
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "386",
      "src": "images/chi-Leong-Fig01001.jpeg",
      "width": "600"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figh"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "data-locator": "p25"
    }
  }), _c('span', {
    staticClass: "fighn"
  }, [_vm._v("FIGURE 1.1.")]), _vm._v(" "), _c('i', [_vm._v("Arcana Fairfaxiana Manuscripta")]), _vm._v(", 63.")])]), _vm._v(" "), _c('p', [_vm._v("In later years Henry and Mary’s younger son, Brian Fairfax, also took an interest in the household recipe book and wrote several entries, including a drink for the plague, a copy of the instructions to make Dr. Chamber’s water, and a series of miscellaneous recipes."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/ChiLeong0018#en92",
      "id": "en92r"
    }
  }, [_vm._v("21")])]), _vm._v(" As it stands, the "), _c('i', [_vm._v("Arcana Fairfaxiana")]), _vm._v(" offers clear traces of how generations of the extended Fairfax family collectively worked on their book of recipe knowledge over long time spans by entering information into the volume and by actively commenting on each other’s entries. Thus household recipe books like this one are open-ended projects growing alongside the family.")]), _vm._v(" "), _c('p', [_vm._v("These family-wide collaborations muddy the waters when it comes to gendering knowledge production. One example is Nicholas Blundell’s (1699–1737) “great diurnal” where he notes down instances of recipe exchange or his own work on the family recipe book. Although Blundell refers to the family recipe book as “my Wives book of Cookery,” he spent a day making an index for it, hired a scribe, Edward Howard, to write out recipes in the book, and recorded the dates of recipe donations. As Sara Pennell argues, the involvement of male members of the household “does not . . . render manuscript recipe collections invalid as a means through which to study female knowledge formation.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/ChiLeong0018#en93",
      "id": "en93r"
    }
  }, [_vm._v("22")])]), _vm._v(" However, the collaborative aspect of recipe compiling does encourage us to acknowledge nuances in the gendering of recipe knowledge. For some families, at least, gathering recipes and recording them in notebooks was shared by husbands and wives. Responsibility for adding to the family’s stock of practical knowledge flitted between the two. Undoubtedly the power dynamics "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p27"
    }
  }), _vm._v("between family members in these acts shifted according to individual interests, points in the life cycle, and access to resources. Acknowledging the different roles various family members adopted lets us gain a clearer picture of the making of household recipe knowledge, one characterized by collective and collaborative endeavors.")]), _vm._v(" "), _c('h3', {
    staticClass: "bh",
    attrs: {
      "id": "bh0102"
    }
  }, [_vm._v("Collecting to Cure")]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("In 1699 Samuel Bennett caught a cold. In response, a member of his family, perhaps his mother Anne, applied to Mrs. Marshall of nearby Bruton for a remedy. Just a few months later, Samuel suffered a nosebleed. His concerned mother must have mentioned his condition to kinswoman Katherine Pelham, since she later wrote in the entry titled “for to stop Bleeding of the nose cousin Katherine pelham 1700 the 17"), _c('sup', [_vm._v("th")]), _vm._v(" of December for Samuel if he should bleed again.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/ChiLeong0018#en94",
      "id": "en94r"
    }
  }, [_vm._v("23")])]), _vm._v(" This type of collecting practice—the targeted gathering of health-related knowledge to solve a problem at hand—is evident throughout the Bennett and Palmer family books.")]), _vm._v(" "), _c('p', [_vm._v("Reading between recipes, we get some sense of a few family members’ states of health. Certainly Philip and Anne Bennett were offered advice on dealing with their own bodily ailments. A remedy collected from “Goody Colling” on 5 September 1702, geared toward a tertian ague, involved boiling rue in some brandy. As the fever fit approached, the family member was instructed to apply the brandy as hot as can be suffered on the patient’s wrists. As the “cold fit” approached, the patient was to drink some of the brandy mixed with water. This simple remedy was to be repeated until the patient recovered. Either Philip or Anne ended this entry with the powerful endorsement of “this cured mine.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/ChiLeong0018#en95",
      "id": "en95r"
    }
  }, [_vm._v("24")])]), _vm._v(" In another instance, during a family visit with “Sister Shute” in Kilmersdon in June 1715, either Philip or Anne was struck by a violent cold, which was alleviated by a medicine their hosts offered. The recipe for this remedy, “for a violent cold and exceeding cough,” was subsequently entered in the family book with the personal endorsement that the medicine had done much good on that occasion."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/ChiLeong0018#en96",
      "id": "en96r"
    }
  }, [_vm._v("25")])]), _vm._v(" In this case writing down the cold and cough remedy served both as know-how for future bouts of sickness and as a record of their personal suffering.")]), _vm._v(" "), _c('p', [_vm._v("One of the daughters, Katherine, seems to have been sickly. In April 1697 a recipe was collected from Florence Mompesson, since Katherine was feeling “so weeke and colourless.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/ChiLeong0018#en97",
      "id": "en97r"
    }
  }, [_vm._v("26")])]), _vm._v(" She was again feeling weak in January 1709 and was simply described as “sick” in August 1713 when the "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p28"
    }
  }), _vm._v("family collected two recipes in response to her sickness."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/ChiLeong0018#en98",
      "id": "en98r"
    }
  }, [_vm._v("27")])]), _vm._v(" The first recipe was collected from Cousin Margaret Trowbridge on 25 August, and four days later a second recipe was collected from Dr. Rowland Cotton."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/ChiLeong0018#en99",
      "id": "en99r"
    }
  }, [_vm._v("28")])]), _vm._v(" This pattern suggests that when Katherine was ill the family first looked within itself for a remedy and, when that did not perform as desired, they paid a medical practitioner."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/ChiLeong0018#en100",
      "id": "en100r"
    }
  }, [_vm._v("29")])]), _vm._v(" The final ailment Katherine suffered was an eye affliction that bothered her in September 1718. The family recorded five recipes for eye ailments in that month, including a recipe “for a bruise or a stickes hurting an eye, Hannah Draper for my daughter Katherine,” dated 23 September. On the same day they wrote down two more recipes “for the same.” These were taken from a “Madam Madox” and a “Mr John Albin of Brewham.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/ChiLeong0018#en101",
      "id": "en101r"
    }
  }, [_vm._v("30")])]), _vm._v(" Further collected recipes suggest that Katherine’s eye condition did not improve from using the recipes collected that day in September."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/ChiLeong0018#en102",
      "id": "en102r"
    }
  }, [_vm._v("31")])]), _vm._v(" That the final recipe did not come in until nearly four months later also signifies the length of Katherine’s suffering.")]), _vm._v(" "), _c('p', [_vm._v("Like the Bennetts’ collection, Archdale Palmer’s notebook contains recipes used in specific bouts of sickness. Archdale’s wife, Martha, suffered from melancholy in the spring of 1662, and Archdale found a recipe from a “Pagett” to alleviate her symptoms."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/ChiLeong0018#en103",
      "id": "en103r"
    }
  }, [_vm._v("32")])]), _vm._v(" In another instance, on 4 June 1668, Palmer wrote down a series of recipes including a cordial julep, a cordial, and a drink for dropsy. These were labeled as for M (presumably Martha) Palmer and given by Phillippe Launder. The drink for the dropsy receives further endorsement: Palmer notes that it was Major Babbington’s."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/ChiLeong0018#en104",
      "id": "en104r"
    }
  }, [_vm._v("33")])]), _vm._v(" In addition to these hints about Martha Palmer’s health over the years, the Palmer family book also provides an interesting picture of community reactions to the plague. In early summer 1665, when the plague had again broken out in London, no fewer than eight plague cures were written into the book."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/ChiLeong0018#en105",
      "id": "en105r"
    }
  }, [_vm._v("34")])]), _vm._v(" Many of the plague cures of the day came with two sets of instructions—one for prevention and another for those already infected. For the most part, the infected patient would need to take more of the cure than for prevention, and in a few cases extra ingredients were added. The remedies the Palmer family gathered are fairly representative of plague medicaments of the time. The ingredients listed, such as mithridate, treacle (whether London or Venice), rue (also known as herb of grace), and vinegar were all well-known and often-used remedies for the plague."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/ChiLeong0018#en106",
      "id": "en106r"
    }
  }, [_vm._v("35")])]), _vm._v(" Ultimately the 1665 plague did not spread to Leicestershire that summer, but Palmer’s collecting suggests that just the rumor of an epidemic sparked discussions and recipe exchange."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/ChiLeong0018#en107",
      "id": "en107r"
    }
  }, [_vm._v("36")])]), _vm._v(" The four attributed recipes show that the family not only looked among extended family "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p29"
    }
  }), _vm._v("and friends, such as “Cousin Adderley” and Mrs. Whatton, but also turned to learned physicians such as Dr. “Micklethwayth.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/ChiLeong0018#en108",
      "id": "en108r"
    }
  }, [_vm._v("37")])])]), _vm._v(" "), _c('p', [_vm._v("The Palmers and the Bennetts, of course, were not alone in gathering medical information in reaction to particular bouts of sickness within their own households. While recipes of this sort make up only a small portion of any given collection and account for a small area of a family’s collecting practices, this type of reactive compilation is widely evident. Within the bundle of loose recipes in the Glyd/Brockman papers (discussed further in "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/ChiLeong0014#ch05"
    }
  }, [_vm._v("chapter 5")]), _vm._v(") is one for an “opening drink that is very good to drink about a month before delivery.” The recipe advises the maker to boil a range of plant materials (half a dozen roots, a couple of kinds of seeds, and a handful of various fruits) in water and wine to make a concentrated liquid that was then to be mixed with a little sweet almond oil. Dated 1686 and subsequently attributed to a Mrs. Streats, the recipe arrived in the Glyd/Brockman collection just before Anne Glyd Brockman’s sister Martha gave birth to little Martha Drake."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/ChiLeong0018#en109",
      "id": "en109r"
    }
  }, [_vm._v("38")])]), _vm._v(" Another letter within the collection, written by Anne Glyd Brockman’s daughter Ann Boys, offered a recipe for “a water very good for ani heates.” This came with a personal plea from Boys, who wrote, “pray mother let ther be sume of this water made and take it I am perswaded it will doe you a greate deale of good.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/ChiLeong0018#en110",
      "id": "en110r"
    }
  }, [_vm._v("39")])]), _vm._v(" In these cases, sharing health-related information was a way family members expressed their concern and affection. Here compilers were collecting not only "), _c('i', [_vm._v("with")]), _vm._v(" their family but "), _c('i', [_vm._v("for")]), _vm._v(" their family. Given the size and scope of many surviving household recipe books, it is unlikely that their compilers used or witnessed every recipe in the book. In that sense recipe books cannot be taken as direct reflections of a household’s experiences with sickness. However, the health concerns of a particular household undeniably shaped their collection of recipe knowledge in profound ways.")]), _vm._v(" "), _c('h3', {
    staticClass: "bh",
    attrs: {
      "id": "bh0103"
    }
  }, [_vm._v("Calling on Family and Kin")]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("Extended family and kin, variously described, also contributed to a recipe collection in other ways. Within the Palmer and Bennett collections, a significant portion of recipes are attributed to donors described as family members: sisters, aunts, cousins, sons, daughters, and in-laws. Examples include the recipe for treacle water given to Archdale on 25 May 1666 by “Sister Gore” and the two recipes, one for a surfett and another to ease the pain of a sore breast, by “Sister Mary Palmer.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/ChiLeong0018#en111",
      "id": "en111r"
    }
  }, [_vm._v("40")])])]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "p30"
    }
  }), _vm._v("Practical know-how from family and kin entered early modern recipe notebooks by a variety of paths. As we saw earlier with the Glyd/Brockman family letters, recipes circulated within the large family and household correspondence networks. The collection of Elizabeth Freke (1642–1714), for example, contains a letter from her sister Lady Austen enclosing Lady Powell’s recipe for laudanum."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/ChiLeong0018#en112",
      "id": "en112r"
    }
  }, [_vm._v("41")])]), _vm._v(" Accompanying the recipe is an account of Austen’s own positive experience with the cure, including precise dosage, and her recommendation that her sister try this medicine.")]), _vm._v(" "), _c('p', [_vm._v("Aside from correspondence, face-to-face visits also were fruitful occasions for recipe exchange. Palmer’s collection suggests that guests at Wanlip Manor were often called on to contribute to his ever-growing compendium of medical information. When his daughter-in-law Elizabeth D’Anvers Palmer visited Wanlip in late June/early July 1662, she gave Archdale six recipes for accomplishing household tasks such as making mustard, roasting a pike, stilling snail water to treat consumption, and washing ribbons."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/ChiLeong0018#en113",
      "id": "en113r"
    }
  }, [_vm._v("42")])]), _vm._v(" When Elizabeth’s father, William D’Anvers, visited Wanlip a little over a year later, he also added to Archdale’s collection with a recipe for “liquoringe of Bootes.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/ChiLeong0018#en114",
      "id": "en114r"
    }
  }, [_vm._v("43")])])]), _vm._v(" "), _c('p', [_vm._v("Within the "), _c('i', [_vm._v("Arcana Fairfaxiana")]), _vm._v(" there are several recipes from Mary and Henry Fairfax’s relatives. For example, Mary’s brother Henry Cholmeley contributed a large number."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/ChiLeong0018#en115",
      "id": "en115r"
    }
  }, [_vm._v("44")])]), _vm._v(" While many of these were copied out in Henry Fairfax’s neat hand, Cholmeley also wrote in recipes himself. For example, he wrote out and signed his name under “A certaine remedy for the toothach if it proceede from heate.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/ChiLeong0018#en116",
      "id": "en116r"
    }
  }, [_vm._v("45")])]), _vm._v(" Henry Fairfax’s own brother Ferdinando also wrote a recipe “For a could” into the book."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/ChiLeong0018#en117",
      "id": "en117r"
    }
  }, [_vm._v("46")])]), _vm._v(" Unlike Henry Cholmeley, Ferdinando neglected to sign his name, and the attribution was later provided by the diligent Henry Fairfax. Perhaps returning the favor, Fairfax himself contributed to Ferdinando and Rhoda’s book, where he wrote, in his distinctive hand, recipes for making “Walnutt water” and a cordial water."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/ChiLeong0018#en118",
      "id": "en118r"
    }
  }, [_vm._v("47")])]), _vm._v(" The recipes the brothers wrote in each other’s books do not overlap with information in their own household books, and it is difficult to reconstruct the exact circumstances that prompted these entries. However, they emphasize the importance of family collaboration in recipe compilation and the openness of household books to contributions from family members outside the nuclear unit. For future generations, these two recipes documented the close relations between the two brothers and their families.")]), _vm._v(" "), _c('p', [_vm._v("In early modern England, kinship terms held a wide range of meanings and were fairly flexible."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/ChiLeong0018#en119",
      "id": "en119r"
    }
  }, [_vm._v("48")])]), _vm._v(" Parents might address their offspring’s spouses "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p31"
    }
  }), _vm._v("as sons and daughters, and siblings might call their siblings’ spouses brothers and sisters. In this way terms such as “sister” could signify a variety of relationships, from biological sister to sister-in-law to half-sister to stepsister. “Cousin” was particularly widely used and could apply not only to the offspring of aunts and uncles but also to more distant kin. The term was also used more generally to establish that a kinship claim existed."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/ChiLeong0018#en120",
      "id": "en120r"
    }
  }, [_vm._v("49")])]), _vm._v(" In some cases, with additional biographical information to hand, we are able to reconstruct the exact relationship between recipe donor and compiler. For example, Elizabeth Freke took recipes from her siblings, aunts, and cousins. These included recipes from “my cousin Penrudock,” two recipes from “my aunt Tregonell,” and recipes from her sisters Lady Austen and Lady Norton."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/ChiLeong0018#en121",
      "id": "en121r"
    }
  }, [_vm._v("50")])])]), _vm._v(" "), _c('p', [_vm._v("In many other instances, however, we lack the relevant information to discover these relationships and networks and thus have to extrapolate, from these brief descriptions, the significance of the citations. Here Naomi Tadmor’s detailed analysis of how kinship terms were used in early modern England provides a good framework for reading our recipe titles and attributions. She argues that the broad meanings and wide range of relationships associated with terms such as “cousin,” “sister,” and “brother” constituted one way families achieved inclusivity and equality. The language of kinship, she writes, “was employed habitually in a wide range of interpersonal relationships to claim recognition, propose social bonds, set moral and religious duties, and postulate many expectations.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/ChiLeong0018#en122",
      "id": "en122r"
    }
  }, [_vm._v("51")])]), _vm._v(" Thus, while further details on recipe source attributions are useful, it is perhaps more helpful to think broadly about the citation of family members. The strength of kinship bonds may have brought certain assurances about the trustworthiness and reliability of the recipe donors. The family bond may also have allowed compilers and donors to exchange recipes within a fairly limited network. That is, recipes, as valued knowledge, could be safely communicated and still be kept “within the family.” Given the substantial role that kin played in the lives of many households, it is not surprising that they collaborated on such a scale."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/ChiLeong0018#en123",
      "id": "en123r"
    }
  }, [_vm._v("52")])])]), _vm._v(" "), _c('h2', {
    staticClass: "ah",
    attrs: {
      "id": "ah0103"
    }
  }, [_vm._v("Friends, Neighbors, and Recipes")]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("Recipe collectors such as Palmer and the Bennetts not only called on family and kin for recipes but also depended on their friends and neighbors. Looking outside the family, this section explores the myriad ways "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p32"
    }
  }), _vm._v("our historical actors turned to their extended kin, friends, and acquaintances to acquire practical know-how. Many, as I will show, both cultivated local social relationships and used them to extend their recipe knowledge. Social structures, networks, and alliances formed one of the main frameworks for exchanging recipes.")]), _vm._v(" "), _c('h3', {
    staticClass: "bh",
    attrs: {
      "id": "bh0104"
    }
  }, [_vm._v("Recipes, Reading, and Sociability")]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("Social gatherings were fertile ground for gathering recipes, and compilers’ existing social and local networks crucially shaped their access to such knowledge. By all accounts, Palmer seemed to always be on the lookout for new recipes and had a knack for turning dinner conversations toward household know-how."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/ChiLeong0018#en124",
      "id": "en124r"
    }
  }, [_vm._v("53")])]), _vm._v(" On 13 May 1663, after the Northamptonshire minister Mr. Hollid dined with the Palmers, he returned the kindness by leaving Archdale with two recipes: one “For a bone of pinne in the throate” and another “for the Ricketts.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/ChiLeong0018#en125",
      "id": "en125r"
    }
  }, [_vm._v("54")])]), _vm._v(" When Palmer himself visited friends and family, often dining with them, he continued to press for recipes. For example, he collected instructions for a remedy for a fever from “Cousin Peacocke” after a dinner at “Father Smith’s” on 12 March 1662/63."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/ChiLeong0018#en126",
      "id": "en126r"
    }
  }, [_vm._v("55")])]), _vm._v(" When he visited Dr. Bowles and his wife in Oundle on 16 April 1659, he returned home with recipes for cordials and two remedies for sore teeth and mouth cankers in children."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/ChiLeong0018#en127",
      "id": "en127r"
    }
  }, [_vm._v("56")])]), _vm._v(" A visit to his old university town, Cambridge, provided instructions for growing asparagus, confided by William Moses, master of Pembroke Hall."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/ChiLeong0018#en128",
      "id": "en128r"
    }
  }, [_vm._v("57")])])]), _vm._v(" "), _c('p', [_vm._v("Social acquaintances could also extend one’s network of recipe knowers and pass on know-how they themselves had collected from others. For example, one recipe in Palmer’s collection is titled “2"), _c('sup', [_vm._v("d")]), _vm._v(" Receit for a Burne or a scald. Given mee by one Eliz: Janes 8"), _c('sup', [_vm._v("th")]), _vm._v(" Janu: 1669/70 Kinn to Eliz: Woodcock Onelepp.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/ChiLeong0018#en129",
      "id": "en129r"
    }
  }, [_vm._v("58")])]), _vm._v(" It was not uncommon to receive recipes at second or even third hand. On 9 March 1663/64, for example, Palmer received a recipe for scurvy from his cousin Peacocke labeled “Sir Geo: Penrudducks Receite given of him by Lo: Ruthen & given mee by Cous: Peacocke 9"), _c('sup', [_vm._v("th")]), _vm._v(" March 1663/4.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/ChiLeong0018#en130",
      "id": "en130r"
    }
  }, [_vm._v("59")])]), _vm._v(" The connection of multiple authors with single recipes represents both the compilers’ interest in the many hands a recipe had experienced and their recognition of collaborative knowledge making. The notion of authorship in relation to these recipes is more complex than individual creatorship or proprietorship. Aside from personally offering recipe knowledge, family members could also host gatherings where recipes were exchanged. An entry in Palmer’s book is described as "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p33"
    }
  }), _vm._v("“For any Ague but onely a Quartan. Given to mee by Cous: Gabriel Taylor. 8"), _c('sup', [_vm._v("th")]), _vm._v(" June ano: 72 in Sister Stanleys house in Leicester.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/ChiLeong0018#en131",
      "id": "en131r"
    }
  }, [_vm._v("60")])])]), _vm._v(" "), _c('p', [_vm._v("Informal social and knowledge networks also brought access to unfamiliar texts. Large-scale copying of existing manuscripts, when accessible, was fairly common. One interesting illustration is the recipe collection of James Tyrrell (1642–1718)."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/ChiLeong0018#en132",
      "id": "en132r"
    }
  }, [_vm._v("61")])]), _vm._v(" Tyrrell, a political theorist and historian and a friend of the natural philosopher John Locke (1632–1704), composed a small notebook of recipes with extracts taken from several sources. The book begins with the following inscription: “These following Receipts I had among Mr Hartlibs collections in the possession of my Lord Brereton in his Library at Brereton Hall 1685”; this is followed by a section headed “Receipts from Mr Lock’s Collections 1691.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/ChiLeong0018#en133",
      "id": "en133r"
    }
  }, [_vm._v("62")])]), _vm._v(" The inscriptions not only betray Tyrrell’s long-standing interest in recipe knowledge but also provide a rare glimpse into his personal consultations of the Anglo-Prussian intelligencer and reformer Samuel Hartlib’s (c. 1600–1662) papers, which included his "), _c('i', [_vm._v("Ephemerides")]), _vm._v(" and extensive correspondence with virtuosi such as Robert Boyle, William Petty, John Aubrey, John Beale, and others."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/ChiLeong0018#en134",
      "id": "en134r"
    }
  }, [_vm._v("63")])]), _vm._v(" The papers and their afterlives have a complicated history—by 1667 they were in the library of William Brereton, third Baron Brereton of Leighlin (1631–1681) at Brereton Hall in Cheshire, where Tyrrell encountered them in the 1680s."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/ChiLeong0018#en135",
      "id": "en135r"
    }
  }, [_vm._v("64")])]), _vm._v(" Tyrrell’s small selection from Hartlib’s papers included a number of recipes taken out of various letters, including, for example, a recipe for “Spiritus Calcis Vivae” by Basil Valentine, sent first from Sir Kenelm Digby to Robert Boyle and then forwarded to Samuel Hartlib and his son-in-law Frederick Clodius (1629–1702) for production. Another example is the set of recipes sent to Hartlib by Boyle’s sister, Katherine Jones, Lady Ranelagh, that include Sir Kenelm Digby’s “secrets” against “festers and inflamations” that came with “extraordinary commendation.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/ChiLeong0018#en136",
      "id": "en136r"
    }
  }, [_vm._v("65")])]), _vm._v(" Like many other compilers, Tyrrell had particular medical interests—in his case it was cures for kidney stones. Here Tyrrell copies a run of recipes to ease suffering from kidney stones gathered from a number of sources, from Dr. Mackellow to “Mr Wood,” perhaps the antiquary Anthony à Wood, to a London merchant."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/ChiLeong0018#en137",
      "id": "en137r"
    }
  }, [_vm._v("66")])]), _vm._v(" Nine years later Tyrrell expanded his collection of recipes with a lengthy selection out of John Locke’s collection. This section again consisted of recipes by a wide range of contributors, from unknown women such as Mrs. Clerk, Mrs. Higgins of Bristol, and Mrs. Jep to well-known authors such as Thomas Sydenham and Robert Boyle."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/ChiLeong0018#en138",
      "id": "en138r"
    }
  }, [_vm._v("67")])]), _vm._v(" Tyrrell evidently began to see his reading notes from these two collections as a unit, constructing a "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p34"
    }
  }), _vm._v("partial table of contents spanning both these extracts."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/ChiLeong0018#en139",
      "id": "en139r"
    }
  }, [_vm._v("68")])]), _vm._v(" Tyrrell’s transcription of the Hartlib Papers occupied a mere twelve folios, emphasizing the strict selection that occurred during copying. Even when copying from a reputable source, compilers chose what they deemed most useful and suitable for their own needs.")]), _vm._v(" "), _c('p', [_vm._v("Recipe gatherers not only were keen to get their hands on manuscript texts but also relished and took advantage of temporary access, often offered during social or family visits, to expensive or harder-to-obtain printed books. When Elizabeth Freke stayed with her sister Lady Frances Norton and her niece Lady Grace Gethin,"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/ChiLeong0018#en140",
      "id": "en140r"
    }
  }, [_vm._v("69")])]), _vm._v(" she made extensive copies from two contemporary pharmacopoeias—William Salmon’s translation of George Bate’s "), _c('i', [_vm._v("Pharmacopoeia Bateana")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/ChiLeong0018#en141",
      "id": "en141r"
    }
  }, [_vm._v("70")])]), _vm._v(" and the English translation of Moise Charas’s "), _c('i', [_vm._v("Pharmacopée royale galenique et chimique")]), _vm._v(", which was first printed for John Starkey and Moses Pitt in 1678 as "), _c('i', [_vm._v("The Royal Pharmacopoea, Galenical and Chymical")]), _vm._v("."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/ChiLeong0018#en142",
      "id": "en142r"
    }
  }, [_vm._v("71")])]), _vm._v(" Within Freke’s notes from these two volumes, recipes from the printed texts are intermingled with entries on the same ailments from her sister Lady Norton and her niece Lady Gethin. The clustering of these recipes suggests that Freke paired her reading of the two printed volumes with family conversations on similar topics. The results of this reading and informal discussion among the three women can be seen in the alternating arrangement of information gleaned from print and oral sources. Freke’s reading of printed medical books is thus embedded within her social milieu. Here printed books not only offered new information but also sparked dialogues within her household.")]), _vm._v(" "), _c('h3', {
    staticClass: "bh",
    attrs: {
      "id": "bh0105"
    }
  }, [_vm._v("Local Networks of Recipe Knowledge")]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("Whereas Palmer’s notes reveal his wide-ranging social engagements, the names of recipe donors in the Bennett notebook paint the picture of a family with strong local links. In 1668 Philip Bennett the elder purchased South Brewham Manor from Francis Swanton, and by the second generation the family appears to have been active in the local community. Philip Bennett the elder and younger both served as clerks of peace of Somerset. Philip the younger was also treasurer of the Wincanton Fire Relief Fund in 1707."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/ChiLeong0018#en143",
      "id": "en143r"
    }
  }, [_vm._v("72")])]), _vm._v(" Scanning the place-names cited in the notebook shows that a large proportion of the recipes were collected from individuals living in towns and villages surrounding the Bennetts’ home in Brewham. More than ten recipes in the collection were gathered from friends and relatives living in their hometown of Brewham, the neighboring towns of Bruton and Batecombe,"), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p35"
    }
  }), _vm._v(" and the village of Kilmersdon. Almost thirty towns and villages are listed in the Bennett family recipe collection, most of them within the corner of the country where modern-day Somerset borders Wiltshire. The majority of the places cited, such as Bruton, Lamyatt, Upton Noble, Castle Cary, Stourton, and Wincanton, are within ten miles of the Bennetts’ home, suggesting that they tended to gather recipe knowledge from members of their local community.")]), _vm._v(" "), _c('p', [_vm._v("Two readings of “proximity”—geographic and family—framed these recipe-collecting practices. In the Bennetts’ case, since Bruton and Batecombe were both less than five miles from Brewham, proximity of location accounts for how frequently they appear in the notebook. Kilmersdon, however, was approximately fifteen miles away and was one of the farthest villages from the Bennetts’ base. In this case it is likely that family relationships account for the town’s repeated presence in the notebook, since the entries are attributed to “Cousin Margaret Trowbridge” and “Sister Shute.” Social visits with relatives at Kilmersdon not only allowed the Bennetts to tap into the medical knowledge of their hosts but also introduced them to local experts and knowledge networks. As described above, Katherine Bennett’s sickness in Kilmersdon in 1713 brought the Bennetts into contact with Dr. Rowland Cotton. The collection also contains information gleaned from other sources in Kilmersdon, including Thomas Maggs and Jeane Clarke, suggesting that the Bennetts found visits to the village fruitful for recipe gathering."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/ChiLeong0018#en144",
      "id": "en144r"
    }
  }, [_vm._v("73")])]), _vm._v(" Aside from members of their extended family, a large portion of the “local” recipes cited in the Bennetts’ notebook were gleaned from friends, acquaintances, and even passersby. In some cases, such as a recipe taken from “a man of Froom” or “A woman at Major Horners House at Mells,” it appears that the Bennetts did not even recall the contributors’ names. The lack of attribution here could be due to factors from a lack of familiarity to the contributor’s low social status.")]), _vm._v(" "), _c('p', [_vm._v("However, geography did not totally limit householders’ access to medical information. Palmer, for example, traveled extensively around his county and ventured farther afield into the country, gathering recipes and using social visits to tap into “new” networks of knowledge. When Palmer visited his kinswoman Mrs. Palmer in Aston-upon-Trent in Derbyshire on 28 July 1659, he received from her a remedy for toothache that she herself had obtained from Dr. Wright of London."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/ChiLeong0018#en145",
      "id": "en145r"
    }
  }, [_vm._v("74")])]), _vm._v(" The regular travel patterns of the wealthy and landed social groups (to which many recipe book creators belonged) meant that compilers could be part of several “local” "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p36"
    }
  }), _vm._v("networks. A case in point is Johanna St. John, familiar to us from the introduction.")]), _vm._v(" "), _c('p', [_vm._v("As we will learn in more depth in "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/ChiLeong0011#ch02"
    }
  }, [_vm._v("chapter 2")]), _vm._v(", St. John maintained a steady correspondence with her steward Thomas Hardyman during the 1650s and 1660s. Largely based in London, the St. John family relied on their country estate in Lydiard Tregoze for provisions, including ingredients (such as butter) for medicines. The letters reveal that St. John directed Hardyman to ask his wife and the local apothecary, Mr. Goram, to distill waters, to apply to Goody Wolford for herbs, and to plead with Bess the dairymaid to produce enough butter for St. John to make her balsam. Clearly, despite being primarily based in London, St. John was embedded in the local informal knowledge networks of Lydiard. Yet while St. John appears to have relied on her communities of medical knowers in Lydiard Tregoze to produce medicines and foods, these figures do not have a strong presence in her surviving manuscript recipe notebook. Instead, the book is closely tied to London court circles and fashionable physicians. Robert Boyle (1627–1691), his sister Katherine Jones, Lady Ranelagh (1615–1691), and the physicians Thomas Willis (1621–1675), George Bate (1608–1668), and Richard Lower (1631–1691) were all frequent contributors to the volume."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/ChiLeong0018#en146",
      "id": "en146r"
    }
  }, [_vm._v("75")])])]), _vm._v(" "), _c('p', [_vm._v("Additionally, St. John collected recipes from members of her Battersea household, including Mrs. Patrick, wife of the family’s resident chaplain."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/ChiLeong0018#en147",
      "id": "en147r"
    }
  }, [_vm._v("76")])]), _vm._v(" St. John was thus participating in two local knowledge networks. While living in London, she was actively exchanging recipes with notable physicians and acquaintances, and through an intermediary she maintained strong contacts with her other local network at her country estate. The absence of the humbler Lydiard-based knowers in St. John’s recipe book suggests a certain amount of editing on her part, perhaps even a self-conscious fashioning of the recipe book into an object reflecting her elevated social network in London. What is evident here is that the knowledge networks supplying compilers with medical information depended greatly on the social contacts, travel habits, and life patterns of individual compilers. The importance played by local contacts reinforces arguments put forward by other scholars on the importance of early modern communities and neighborliness."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/ChiLeong0018#en148",
      "id": "en148r"
    }
  }, [_vm._v("77")])])]), _vm._v(" "), _c('p', [_vm._v("Local knowledge thus seems to have played a crucial part in the assembling of the early modern recipe books. Yet knowledge gathered locally does not necessarily translate to definable “regional” medical practices or knowledge. Anne Stobart, in her study of domestic medicine in the southwest"), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p37"
    }
  }), _vm._v(" of England, concludes that, despite the geographical parameters of her study, it did not paint a picture of regional medicine."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/ChiLeong0018#en149",
      "id": "en149r"
    }
  }, [_vm._v("78")])]), _vm._v(" Stobart’s in-depth study of the private papers, household accounts, and medical recipe collections of four late seventeenth-century families based in the southwest of England suggests that the resources, social connections, and at times medical needs of many families took them on journeys to London or other major cities. The sophisticated routes of knowledge transfer via vernacular print, correspondence, and travel meant that recipe knowledge circulated widely. The scope of “venturing out” of their local knowledge networks undoubtedly varies from one compiler to the next. Many compilers, much like Archdale Palmer, continued to collect recipes while away from home, bringing in knowledge and ideas gleaned from beyond their immediate geographic or social vicinity. That is not to say there are not distinctive characteristics that differentiate the medical landscape of different regions or subregions, as Steven King and Alan Weaver have ably shown for eighteenth-century Lancashire, but rather to note that such localism is hard to detect in the family recipe books."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/ChiLeong0018#en150",
      "id": "en150r"
    }
  }, [_vm._v("79")])])]), _vm._v(" "), _c('h3', {
    staticClass: "bh",
    attrs: {
      "id": "bh0106"
    }
  }, [_vm._v("Recipes and the Gift Economy")]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("The central role played by existing social, kinship, and particularly local networks encourages us to read recipe transfer alongside exchanges in other economies and as part of a larger framework of obligation and patronage."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/ChiLeong0018#en151",
      "id": "en151r"
    }
  }, [_vm._v("80")])]), _vm._v(" Recently a number of studies have highlighted the important role played by medical gifts. In particular, Alisha Rankin’s study of pharmacy in the sixteenth-century German court argues for the need to view the exchange of recipes, materia medica, distillation equipment, and the like within the larger “economy of scientific exchange.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/ChiLeong0018#en152",
      "id": "en152r"
    }
  }, [_vm._v("81")])]), _vm._v(" Similarly, Meredith Ray has written of the flurry of recipes, perfumes, and more exchanged among women in Renaissance courts and in particular in the circle of Caterina Sforza."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/ChiLeong0018#en153",
      "id": "en153r"
    }
  }, [_vm._v("82")])]), _vm._v(" In the early modern English context, gifts of recipes likely functioned within what economic historians have termed “economies of obligation,” where social and moral credit or reputation worked alongside economic credit to delineate financial, material, and knowledge exchanges."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/ChiLeong0018#en154",
      "id": "en154r"
    }
  }, [_vm._v("83")])]), _vm._v(" Household members consequently participated in complex and overlapping networks of reciprocity and obligation. The correspondence between Edward Conway (1594–1655) and Edward Harley (1689–1741) furnishes a clear articulation of this practice. In 1651 Conway wrote in a letter to his nephew Harley:")]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "bqs"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "p38"
    }
  }), _vm._v("My Lady of Westmerland hath two Receipts the one the preparation of Oxe Galles, the other A water of Mirrhe, both of them washes for the face, if you have so mutch credite with hir I pray get them of hir, and communicate them to mee they are very excellent and you will thanke me for them."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/ChiLeong0018#en155",
      "id": "en155r"
    }
  }, [_vm._v("84")])])])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_vm._v("In this instance it turns out that Harley’s credit with Mary Fane (c. 1611–1669), wife of Mildmay Fane, second Earl of Westmorland (1602–1666), was sufficient, since a few months later he sent the requested recipes."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/ChiLeong0018#en156",
      "id": "en156r"
    }
  }, [_vm._v("85")])]), _vm._v(" The explicit mention of credit here reminds us of the high value placed on both social reputation and practical knowledge. Access to a family’s recipes was not granted to just anyone, but only to those who had proved worthy. In fact, granting access to one’s own practical knowledge was akin to a gift, a favor that must be recorded and returned. Certainly, within the Conway/Harley correspondence, a recipe was offered with the expectation of repayment in kind. For example, in a letter dated 14 January 1650/51, Conway acknowledged Harley’s gift of recipes by writing, “I thanke you very mutch but will thanke you better for I will send you some in exchange.” In a later letter Conway wrote specifically of being “in debt” to Harley for both his letter and his recipes."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/ChiLeong0018#en157",
      "id": "en157r"
    }
  }, [_vm._v("86")])])]), _vm._v(" "), _c('p', [_vm._v("Offers of single recipes were also made in a bid for patronage or other goods. Within the Bagot papers at the Folger Shakespeare Library, for example, is a letter by Mercurius Patten offering two recipes for deafness to his patron Sir Walter Bagot in hopes that Mrs. Bagot might bestow a piece of bacon on his household."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/ChiLeong0018#en158",
      "id": "en158r"
    }
  }, [_vm._v("87")])]), _vm._v(" In these cases the value of the recipe is made clear as recipe knowledge is exchanged for everyday goods. Contemporary customs and patterns governing gift exchange and economies of credit and obligation were therefore central to the transfer of recipe knowledge."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/ChiLeong0018#en159",
      "id": "en159r"
    }
  }, [_vm._v("88")])])]), _vm._v(" "), _c('p', [_vm._v("Besides gifts of single recipes, it was also common to present entire collections of recipes as gifts. The producers of printed recipe collections adopted the common early modern practice of using dedicatory epistles to garner favors and seek patronage."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/ChiLeong0018#en160",
      "id": "en160r"
    }
  }, [_vm._v("89")])]), _vm._v(" For example, the popular "), _c('i', [_vm._v("A Choice Manual of Rare and Select Secrets in Physick and Chyrurgery")]), _vm._v(" is dedicated to the “vertuous and most Noble lady” Letitia Popham, wife of Colonel Alexander Popham. Within the letter the book producer, W. J., offers this “small Manuall, which was once esteemed as a rich Cabinet of Knowledge,” as a gift worthy of Mrs. Popham’s patronage. The gift, according to the dedicator, was his way of expressing gratitude for past favors granted by Colonel Popham."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/ChiLeong0018#en161",
      "id": "en161r"
    }
  }, [_vm._v("90")])])]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "p39"
    }
  }), _vm._v("While book producers might have relied on book dedications to position recipe collections as gifts, early modern householders could give actual notebooks as presents. Many examples can be found in the recipe archive. In one case “Poore Colly” offered her patroness a presentation copy of a treasury of recipes by another woman, Hester Gullyford. Colly’s inscription reads, “This book humbly beggs Madam Elizabeth Butler her acceptance from her faythfull servant, March the last 1679, Poore Colly.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/ChiLeong0018#en162",
      "id": "en162r"
    }
  }, [_vm._v("91")])]), _vm._v(" Another example is the recipe collection of Cecilia Haynes Mildmay, which has “Ci Mildemay 1663” written on the first folio and “Lady Anne Lovelace gave me this book Cisilea Haynes 1659” on the recto of the second folio."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/ChiLeong0018#en163",
      "id": "en163r"
    }
  }, [_vm._v("92")])]), _vm._v(" Cecilia evidently so treasured Lady Anne’s gift that she reinscribed it and carried it to her new home upon marriage. In both of these cases we might locate the gift of a recipe collection alongside other presents commonly exchanged by English aristocrats and gentlewomen. Certainly a beautiful leather-bound, embossed recipe book is not only a gift of treasured recipe knowledge but also a representation of the resources required and care taken to produce such an object. As such, within the gift economy such books probably functioned like other lovingly handmade objects such as marmalades, embroidery, and made-up medicines often used to consolidate female alliances."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/ChiLeong0018#en164",
      "id": "en164r"
    }
  }, [_vm._v("93")])])]), _vm._v(" "), _c('p', [_vm._v("Significantly, many recipe collections circulated far beyond immediate family members and were pored over by neighbors and acquaintances. For example, lending one’s collection to others, as Florence Mompesson shared hers with the Bennetts, gave the borrower of the book a chance to closely study one’s collection. As we saw above with the Fairfax family, neighbors, friends, and relatives often copied entries from a family’s compendium of recipes, and visitors were encouraged to write their own offerings straight into the notebook. For these inscribers and readers, the book at hand must have offered both medical knowledge and crucial social information. The numerous names cited with individual recipes would have acted as a display of the owners’ own networks and the far-reaching (they hoped) extension of their social credit. By inviting these “outsiders” to share their recipe books, families were also inviting them to witness, marvel at, and appreciate their hard-earned social alliances and family networks.")]), _vm._v(" "), _c('p', [_vm._v("Recipe collections, then, were afforded a dual function within early modern households. On one hand, they were repositories of household knowledge. On the other hand, they were maps of a family’s social network."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/ChiLeong0018#en165",
      "id": "en165r"
    }
  }, [_vm._v("94")])]), _vm._v(" Once circulated among friends and family, the recipe book also "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p40"
    }
  }), _vm._v("served as a public record of a family’s treasury of health and social alliances. To those scanning the various recipes alongside their donors’ names, these books at once proclaimed the wealth of compilers’ credit networks and visibly demonstrated their standing within the community. If we look at this from the recipe donor’s perspective, to have one’s recipe included in the same collection as that of an illustrious aristocrat or a morally upstanding resident of the local village was a way of joining a particular club. Within this framework, existing notions of social credit and moral reputation shaped recipe transactions. Notebooks of recipes, culinary and medical, were thus records of these transactions—a ledger of credit and debt and a tangible demonstration of a family’s overlapping networks.")]), _vm._v(" "), _c('h2', {
    staticClass: "ah",
    attrs: {
      "id": "ah0104"
    }
  }, [_vm._v("Venturing Out: Seeking Knowledge from Experts")]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("In their search for new recipe knowledge, householders often ventured outside their family and social circles. In the Bennett family book, for example, a dozen recipes are attributed to individuals described as “goodman,” “goody,” or “goodwife.” These included a recipe for the ague from Goodman Gerhead Wedmoore on 11 June 1716 and a recipe for the fits in a child from Goody King of Sturton given on 5 May 1707."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/ChiLeong0018#en166",
      "id": "en166r"
    }
  }, [_vm._v("95")])]), _vm._v(" The Bennetts were not alone in recording recipes from this particular group within the community; other gentry compilers such as the Carey family also considered the knowledge of local men and women worthy of putting on paper."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/ChiLeong0018#en167",
      "id": "en167r"
    }
  }, [_vm._v("96")])]), _vm._v(" During the period, these terms were used selectively to refer to individuals below gentle status in the social stratum who made significant contributions to the affairs of the parish. David Postles argues that they “had an almost honorific import, and demarcated a select status within a social level, based on service and neighbourliness.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/ChiLeong0018#en168",
      "id": "en168r"
    }
  }, [_vm._v("97")])]), _vm._v(" Thus, while the medical knowledge of apothecaries was worth writing down because of their occupation, the knowledge of Goody King, for example, was considered useful because of her position within the community and her general neighborliness. Perhaps thinking along the same lines, Archdale Palmer collected recipes from several clergymen including Mr. Jenner, described as a minister in Ireland, Mr. Hollid, a minister in Northamptonshire, Mr. Smith, the “late Minist. Of Oneleppe,” Mr. Campion, a minister in Shropshire, and finally Mr. Sedon."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/ChiLeong0018#en169",
      "id": "en169r"
    }
  }, [_vm._v("98")])]), _vm._v(" In this sense the compilers’ assessment of the “knowers” of practical information is, as Craig Muldrew has demonstrated for credit and obligation, based on social reputation and moral standing."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/ChiLeong0018#en170",
      "id": "en170r"
    }
  }, [_vm._v("99")])])]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "p41"
    }
  }), _vm._v("When it comes to medical recipes, we commonly find entries attributed to persons labeled “Dr” in the recipe books. “Doctor” was a somewhat ambiguous descriptor in the early modern period. Many contemporaries employed it to denote any person practicing medicine rather than only university-trained physicians, as well as those trained in theology."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/ChiLeong0018#en171",
      "id": "en171r"
    }
  }, [_vm._v("100")])]), _vm._v(" However, within the recipe archive there are also a significant number of instances where we can identify the cited medical practitioner, providing rich case studies of medical practice and, in particular, how householders combined home-based health care with services obtained on the medical marketplace."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/ChiLeong0018#en172",
      "id": "en172r"
    }
  }, [_vm._v("101")])])]), _vm._v(" "), _c('p', [_vm._v("Prescriptions from physicians and other practitioners could have ended up in household recipe collections through several paths. Certainly some were provided in face-to-face consultations. For example, as I noted earlier, Johanna St. John’s recipe book contains entries from the well-known physicians and natural philosophers Thomas Willis and Richard Lower. A number of these are clearly the result of medical consultations."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/ChiLeong0018#en173",
      "id": "en173r"
    }
  }, [_vm._v("102")])]), _vm._v(" For example, one recipe is labeled “A Snayl water Dr Willis prescribed me when I was with child for sharpnes in my blood.” This was followed by a series of remedies linked to pregnancy and childbirth, many attributed to Willis, suggesting these might be also from direct consultations."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/ChiLeong0018#en174",
      "id": "en174r"
    }
  }, [_vm._v("103")])]), _vm._v(" Likewise, St. John seemed to have been a patient of Dr. Lower. In the margin of a recipe titled “Sr Edward Greaves For the Scirvies” she wrote, “Dr Lower bid me add powder of perl & corral & crabs eyes to this of each half an ounce.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/ChiLeong0018#en175",
      "id": "en175r"
    }
  }, [_vm._v("104")])]), _vm._v(" St. John also recorded a recipe titled “Syrope of Steel Dr Lower gave me & which he uses.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/ChiLeong0018#en176",
      "id": "en176r"
    }
  }, [_vm._v("105")])])]), _vm._v(" "), _c('p', [_vm._v("Another example can be found in the recipe book associated with the family of Henry Carey, second Earl of Monmouth (1596–1661), and his wife, Martha, which contains detailed instructions given by Dr. George Bate (1608–1668) for Henry and Martha Carey and by Dr. Theodore Mayerne (1573–1655) for their daughters Theophila and Mary in the mid-1650s."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/ChiLeong0018#en177",
      "id": "en177r"
    }
  }, [_vm._v("106")])]), _vm._v(" Both Bate and Mayerne were active members of the College of Physicians and fashionable physicians at the time. Whereas Mayerne was connected to the Stuart court (he was physician to both James I and Charles I), Bate was the physician to Charles I and Charles II and also to Oliver Cromwell."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/ChiLeong0018#en178",
      "id": "en178r"
    }
  }, [_vm._v("107")])]), _vm._v(" The recipes in question are titled “Dr Mayernes Method for Lady Theophila Cary’s Cold 1654 May” and “Dr Mayerne’s method for the Lady Mary Cary’s cold May the 17"), _c('sup', [_vm._v("th")]), _vm._v(" 1653.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/ChiLeong0018#en179",
      "id": "en179r"
    }
  }, [_vm._v("108")])]), _vm._v(" Both these entries recommended a series of medicines and diet drinks for the patients as well as giving precise instructions for phlebotomy."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/ChiLeong0018#en180",
      "id": "en180r"
    }
  }, [_vm._v("109")])]), _vm._v(" The entry "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p42"
    }
  }), _vm._v("for Lady Mary Carey’s cold, for example, included a “pectorall decoction,” a purge, a recipe to make a china broth, and a recipe for lozenges for the cough, which Lady Mary was instructed to melt under her tongue."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/ChiLeong0018#en181",
      "id": "en181r"
    }
  }, [_vm._v("110")])])]), _vm._v(" "), _c('p', [_vm._v("Since patients often corresponded with their medical practitioners, it is also not unusual to find original consultation letters preserved alongside recipes."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/ChiLeong0018#en182",
      "id": "en182r"
    }
  }, [_vm._v("111")])]), _vm._v(" Anne Meyricke, for example, copied out instructions addressed to her from her physician Dr. John Powell. In his instructions, Powell advised her to obtain from the apothecary some “antiscorbutick electuary” and to take it every morning with a large quantity of nutmeg. In addition, he told her to drink a posset made with white wine and scurvy grass, brooklime, and horseradish root. Finally, he recommended she take “Bath” water and gave advice on which apothecaries should make up her medicines."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/ChiLeong0018#en183",
      "id": "en183r"
    }
  }, [_vm._v("112")])]), _vm._v(" Another example of this type of correspondence is the letter William Pearce, a surgeon, sent to Sir George Oxinden on 24 March 1662, where he included remedies for gout. A few weeks later Pearce followed up this letter with an inquiry about his patron’s health, with further instructions, and added a postscript that his “Brother Bale is very well versed in those distempers and have good receipts for the same if occasion require.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/ChiLeong0018#en184",
      "id": "en184r"
    }
  }, [_vm._v("113")])]), _vm._v(" While the examples cited here tend to stress householders’ reception of recipe information, we should also bear in mind that physicians and other medical practitioners likely participated in wider, perhaps socially based, exchanges of recipe knowledge. For example, Michael Stolberg has recently shown us how the learned Bohemian physician Georg Handsch (1529–1578?) collected much health-related information from his own family members and their patients."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/ChiLeong0018#en185",
      "id": "en185r"
    }
  }, [_vm._v("114")])])]), _vm._v(" "), _c('p', [_vm._v("Many of the recipes originating from personal medical consultations were passed around to friends and family. In one instance the Bennett family received a recipe for a scurvy remedy from Mr. Sam Boord of Batecombe on 22 April 1710. Mr. Boord was himself taking this remedy on the advice of “his Doctor Warmister.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/ChiLeong0018#en186",
      "id": "en186r"
    }
  }, [_vm._v("115")])]), _vm._v(" Undoubtedly, when Dr. Warmister offered Sam Boord this particular prescription, it was within the regimen he specifically designed for the unique humoral composition of Boord’s body at that moment. For Boord and the Bennetts though, the cure was no longer tied to a particular body on a specific occasion but rather was universalized and ready to be tried and applied to others with similar symptoms. In other words, there was a move from focusing on individual human bodies to addressing particular ailments and diseases across the population. Thus prescriptions that physicians and other medical practitioners gave to their patients on specific occasions entered the general "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p43"
    }
  }), _vm._v("realm of recipe exchange. Taken out of the context of the particular regimen they were created for, these recipes became common knowledge and were applied to patients with similar complaints.")]), _vm._v(" "), _c('p', [_vm._v("Early modern compilers’ desire to gather and record information from doctors needs to be read alongside the know-how they gathered from other experts."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/ChiLeong0018#en187",
      "id": "en187r"
    }
  }, [_vm._v("116")])]), _vm._v(" It was common for compilers to seek information from those whose occupations gave them practical hands-on experience in certain areas. For example, Palmer’s notebook includes a recipe for tobacco obtained from “Mr Clark an Apothecary at Lugborow” while he was staying with his sister D’Anvers at Swithland,"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/ChiLeong0018#en188",
      "id": "en188r"
    }
  }, [_vm._v("117")])]), _vm._v(" a recipe “for a bone spaven” at “Templehall” from a farrier,"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/ChiLeong0018#en189",
      "id": "en189r"
    }
  }, [_vm._v("118")])]), _vm._v(" and two recipes for making stone bottles sweet from “Fran Pochyn of the Mitre Taverne in Cheapside.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/ChiLeong0018#en190",
      "id": "en190r"
    }
  }, [_vm._v("119")])]), _vm._v(" The Bennetts’ book has recipes from Hannah Draper, described as “the Doctors old servant.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/ChiLeong0018#en191",
      "id": "en191r"
    }
  }, [_vm._v("120")])])]), _vm._v(" "), _c('p', [_vm._v("In these particular knowledge transactions, we see the recipe compilers searching for useful information outside their own social and family circles. The need for the “best” set of instructions for particular household tasks encouraged compilers to seek out the widest possible pool of knowledge providers. Palmer’s and the Bennetts’ records of these donors’ occupations suggest that both compilers viewed occupation as central to assessing the donor’s expertise and claim to authority. For Palmer, an apothecary, a farrier, and a tavern keeper were certainly experienced in making medicines, caring for horses and cattle, and keeping bottles smelling sweet. Undoubtedly, in the eyes of the Bennetts, Hannah Draper’s occupation as a “Dr’s” servant afforded her opportunities to gain specialized medical knowledge. Including knowledge from these donors emphasizes the value recipe collectors placed on experiential knowledge."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/ChiLeong0018#en192",
      "id": "en192r"
    }
  }, [_vm._v("121")])]), _vm._v(" The importance of hands-on experience is a theme we will encounter again and again in this book, particularly in later chapters focused on the multistep codifying of recipe knowledge and on trying and testing. Here I note that the high worth accorded to hands-on experience with particular cures or practices prompted compilers to cross social and gender lines in their recipe collecting. Furthermore, this venturing outside one’s social circle also follows arguments put forward by social historians such as Keith Wrightson and Phil Withington."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/ChiLeong0018#en193",
      "id": "en193r"
    }
  }, [_vm._v("122")])]), _vm._v(" The latter convincingly argues that there were particular spaces, such as taverns, where men and women of different social sorts mingled. Within this context, it is not surprising that Archdale Palmer came away from the Mitre Taverne armed with recipes.")]), _vm._v(" "), _c('h2', {
    staticClass: "ah",
    attrs: {
      "id": "ah0105"
    }
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "p44"
    }
  }), _vm._v("Conclusion")]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("Through detailed readings of the Palmer and Bennett recipe books, this chapter has offered a sustained look into the recipe knowledge and social worlds of two early modern families.")]), _vm._v(" "), _c('p', [_vm._v("The compilation practices of these two families highlight the early modern fascination with and need for practical information such as recipes and the informal methods of gaining this knowledge. With their chronological organization, both of the notebooks at the center of this chapter resemble personal journals more than contemporary medical formularies or pharmacopoeias. By paying close attention to the records of recipe exchange, this chapter has explored how such compilers went about filling their notebooks with recipes and how they recorded recipe knowledge. For the Palmer and Bennett families, collecting recipes was part of daily life, and sociability occupied a central place in its shaping and framing.")]), _vm._v(" "), _c('p', [_vm._v("In Archdale Palmer’s notebook, dining rooms, stables, and public taverns all feature as sites for gathering recipes. Consultations with medical practitioners aside, family visits and social calls on friends and neighbors were occasions where medical information and advice were discussed and exchanged. Social visits also brought opportunities to examine and explore new libraries and transcribe passages from manuscript and printed texts into one’s own recipe book. For the keen recipe gatherer, it also opened doors to new social and knowledge networks. Access to trusted and specialized information, whether from texts or from experts of good repute, was a crucial factor in transferring recipe knowledge. Sociability played a vital part in shaping this access.")]), _vm._v(" "), _c('p', [_vm._v("Given that requesting and sharing such knowledge was conducted within the web of social and family relationships, we might consider recipe exchange as an act that created bonds between seeker and donor. After all, to apply for advice, recipe seekers must also confess their ailments and bodily dysfunctions. As recipe donors accept seekers into their knowledge networks by sharing their intimate health issues, recipe seekers also welcome donors into their circle of knowers. The actual processes of collation—asking for recipes, writing them down, and sharing them—are thus in fact social and cultural acts that tie recipe seekers and recipe donors together in new communities and consolidate existing networks and relationships. Consequently, for early modern householders, recipe knowledge represented more than just useful advice on how to alleviate "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p45"
    }
  }), _vm._v("sickness and promote health or to bake the perfect cheesecake; rather, it served a multitude of social and cultural roles. Recipe books, then, should be read as medical, social, and cultural artifacts.")]), _vm._v(" "), _c('p', [_vm._v("Throughout the chapter I have also emphasized that creating recipe knowledge was collective, collaborative, and often cumulative work. This had a number of consequences. First, as we saw in the case studies above, a family’s collective work on its book of recipes often spanned generations. This encourages us to recognize that the texts are largely multiauthor and difficult to date precisely."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/ChiLeong0018#en194",
      "id": "en194r"
    }
  }, [_vm._v("123")])]), _vm._v(" Second, it becomes clear that household recipe knowledge is shaped and framed by family and marriage alliances in addition to connections such as institutional frameworks or social and knowledge networks. Not only did these family ties influence knowledge sources in the form of recipe contributors or recipe exchange networks, but, as we will see in "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/ChiLeong0013#ch04"
    }
  }, [_vm._v("chapter 4")]), _vm._v(", they also had epistemic impact, particularly on trial, testing, and recipe evaluation. Finally, the active involvement of early modern men such as Archdale Palmer, Henry Fairfax, and others reminds us that recipe knowledge interested men and women both. Although historians have often connected the collection and use of household knowledge with the domestic sphere, housewifery, and the female domain, it appears that such knowledge and practice cannot be so neatly categorized. The continual crisscrossing over gender lines in the transfer of knowledge suggests that the gendering of such knowledge was nuanced and complex. The gendering of housework, of which collecting recipe knowledge is firmly a part, was often influenced by the idiosyncrasies of individual partnerships or was in flux, responding to changes wrought by different life stages or economic circumstances. As we will see in the next chapter, in many cases the complex task of ensuring the smooth running of an early modern household required a team of men and women armed with a range of skills and expertise.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e3cac388","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Chi-Leong-0010.vue
// module id = 81
// module chunks = 0